import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_measures_in_place_relate_2'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_measures_in_place_relate_2',
  name: 'Does the facility have any of the following measures in place related to on-site medical treatment?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'MEDICAL_FACILITIES_CLINIC_S_ARE_PROVIDED_WITH_SUPPLIES_AND_EQUI',
      text: 'Medical facilities/clinic(s) are provided with supplies and equipment for the injuries expected',
      externalIds: [
        {
          id: 'hs-51--2-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MEDICAL_FACILITIES_CLINICS_ARE_KEPT_CLEAN_AND_SANITARY',
      text: 'Medical facilities/clinics are kept clean and sanitary',
      externalIds: [
        {
          id: 'hs-51--2-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MEDICAL_FACILITIES_CLINICS_ARE_IN_OPERATION_DURING_ALL_WORKING_',
      text: 'Medical facilities/clinics are in operation during all working hours, including overtime',
      externalIds: [
        {
          id: 'hs-51--2-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MEDICAL_FACILITIES_CLINIC_S_HAVE_AN_APPOINTED_DOCTOR_NURSE',
      text: 'Medical facilities/clinic(s) have an appointed doctor/nurse',
      externalIds: [
        {
          id: 'hs-51--2-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MEDICAL_FACILITIES_CLINIC_S_ARE_EQUIPPED_FOR_MATERNAL_HEALTHCAR',
      text: 'Medical facilities/clinic(s) are equipped for maternal healthcare',
      externalIds: [
        {
          id: 'hs-fir-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MEDICINES_STORED_IN_MEDICAL_FACILITIES_CLINICS_ARE_KEPT_UNDER_L',
      text: 'Medicines stored in medical facilities/clinics are kept under lock and key and only accessible by medical personnel',
      externalIds: [
        {
          id: 'hs-51--2-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-51--2-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'MEDICAL_FACILITIES_CLINIC_S_ARE_PROVIDED_WITH_SUPPLIES_AND_EQUI',
                'MEDICAL_FACILITIES_CLINICS_ARE_KEPT_CLEAN_AND_SANITARY',
                'MEDICAL_FACILITIES_CLINICS_ARE_IN_OPERATION_DURING_ALL_WORKING_',
                'MEDICAL_FACILITIES_CLINIC_S_HAVE_AN_APPOINTED_DOCTOR_NURSE',
                'MEDICAL_FACILITIES_CLINIC_S_ARE_EQUIPPED_FOR_MATERNAL_HEALTHCAR',
                'MEDICINES_STORED_IN_MEDICAL_FACILITIES_CLINICS_ARE_KEPT_UNDER_L',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-fir-2',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16810,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
